import { jsx as a, Fragment as T, jsxs as m } from "react/jsx-runtime";
import { withManagedProps as P } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as h } from "@made-people/react-prop-guard";
import C, { useEffect as Ke, createElement as Ue, isValidElement as Xe, useState as Z } from "react";
import { g as Ye, b as Ze, w as Je, d as U, s as et, q as tt, a as Ne, c as at, e as ot, f as ue, t as _, p as nt, h as E } from "./blueprint-c8c0059d.mjs";
import { useProductBase as B, useProductImages as Pe, useProductProviderContext as rt, ProductLink as de, useProductPriceInfo as me, useProductAttributeGetter as Ee, useProductSiblings as it, useProductOptions as X, useProductHasOptionsInStock as pe, useProductPurchaseStatus as oe, useProductDataModel as xe, useIsBundle as st, useProductAttribute as ct } from "@made-people/grease-product";
import O, { clsx as lt } from "clsx";
import { responsiveImageSchema as ut, ResponsiveImage as Te } from "@made-people/blueprint-responsive-image";
import { useTranslate as z } from "@made-people/grease-translations";
import { Badge as $, badgeSchema as J } from "@made-people/blueprint-badge";
import { AnimatePresence as dt, motion as Be } from "motion/react";
import { buttonAsButtonSchema as q, ButtonAsButton as G, buttonContentPropsSchema as mt, Button as pt } from "@made-people/blueprint-button";
import { useQuickShopAddToCart as gt, useUpdateCart as ne } from "@made-people/grease-cart";
import { overlayEventEmitter as A } from "@made-people/blueprint-overlay";
import { toast as ke } from "sonner";
import { Drawer as le } from "@made-people/blueprint-drawer";
import "@made-people/blueprint";
const ht = (e, n) => {
  Ke(() => {
    if (!n || !e.current || sessionStorage.getItem("swipe-hint-seen"))
      return;
    const r = setTimeout(() => {
      if (!e.current)
        return;
      const i = e.current.querySelector(
        "[data-product-card-gallery]"
      );
      !i || i.children.length <= 1 || sessionStorage.getItem("swipe-hint-seen") || (sessionStorage.setItem("swipe-hint-seen", "true"), i.style.scrollSnapType = "none", i.style.overflowX = "hidden", i.scrollTo({
        left: i.clientWidth * 0.4,
        behavior: "smooth"
      }), setTimeout(() => {
        i.scrollTo({
          left: 0,
          behavior: "smooth"
        }), setTimeout(() => {
          i.style.scrollSnapType = "", i.style.overflowX = "";
        }, 500);
      }, 800));
    }, 1e3);
    return () => clearTimeout(r);
  }, [n, e]);
}, bt = (e, n, o = []) => {
  const [r, i] = C.useState(!0), [s, c] = C.useState(!1), l = C.useCallback(() => e.current ? e.current.querySelector(n) : null, [e, n]), u = C.useCallback(() => {
    const d = l();
    if (!d) {
      i(!0), c(!0);
      return;
    }
    const g = d.scrollWidth - d.clientWidth;
    if (g <= 0) {
      i(!0), c(!0);
      return;
    }
    const b = d.scrollLeft, p = 1;
    i(b <= p), c(b >= g - p);
  }, [l]);
  return C.useEffect(() => {
    u();
    const d = l();
    if (!d)
      return;
    const g = () => u();
    return d.addEventListener("scroll", g, { passive: !0 }), window.addEventListener("resize", u), () => {
      d.removeEventListener("scroll", g), window.removeEventListener("resize", u);
    };
  }, [l, u, ...o]), { isAtStart: r, isAtEnd: s, update: u };
}, ft = ({
  imagesCount: e,
  scrollPosition: n,
  slots: o
}) => /* @__PURE__ */ a(T, { children: Array.from({ length: e }).map((r, i) => {
  const s = Math.round(n) === i;
  return /* @__PURE__ */ a(
    "div",
    {
      role: "tab",
      "aria-selected": s,
      "aria-label": `Image ${i + 1} of ${e}`,
      className: O(
        o.indicatorDot,
        s && o.indicatorDotActive
      )
    },
    i
  );
}) }), yt = ({
  imagesCount: e,
  scrollPosition: n,
  slots: o
}) => /* @__PURE__ */ m("div", { className: o.indicatorScrollbarContainer, "aria-hidden": "true", children: [
  Array.from({ length: e }).map((r, i) => /* @__PURE__ */ a("div", { className: O(o.indicatorScrollbar, "flex-1") }, i)),
  /* @__PURE__ */ a(
    "div",
    {
      className: O(
        o.indicatorScrollbarActive,
        o.indicatorScrollbarOverlay
      ),
      style: {
        left: `${n / e * 100}%`,
        width: `${100 / e}%`
      }
    }
  )
] }), wt = ({
  imagesCount: e,
  scrollPosition: n,
  type: o,
  slots: r
}) => e <= 1 ? null : /* @__PURE__ */ a(
  "div",
  {
    className: r.indicatorWrapper,
    role: "tablist",
    "aria-label": "Image navigation",
    children: o === "scrollbar" ? /* @__PURE__ */ a(
      yt,
      {
        imagesCount: e,
        scrollPosition: n,
        slots: r
      }
    ) : /* @__PURE__ */ a(
      ft,
      {
        imagesCount: e,
        scrollPosition: n,
        slots: r
      }
    )
  }
), ge = t.object({
  className: t.string().optional(),
  imageSettings: ut.optional(),
  variants: t.custom().optional().describe("Variants for the gallery"),
  styling: t.custom().optional().describe("If you want to override the default styling"),
  swipeHint: t.boolean().optional().describe("If you want to enable the swipe hint"),
  arrowNavigation: t.object({
    enabled: t.boolean().optional(),
    leftIcon: t.custom().optional(),
    rightIcon: t.custom().optional()
  }).optional().describe("If you want to enable the scroll arrows"),
  indicator: t.object({
    enabled: t.boolean().optional(),
    showOnMobileOnly: t.boolean().optional(),
    type: t.enum(["dots", "scrollbar"]).optional()
  }).optional(),
  deferImages: t.object({
    enabled: t.boolean().optional(),
    initialCount: t.number().optional()
  }).optional().describe(
    "Render only the first images, deferring the rest until first interaction"
  ),
  children: t.custom().optional()
}), Le = h(ge, (e) => {
  var fe, ye, we, ve, Se, Ie, Ce;
  const n = B(), o = Pe(), r = rt(), i = C.useRef(null), [s, c] = C.useState(0), [l, u] = C.useState(!1), d = C.useCallback(
    () => u(!0),
    []
  ), g = 2, b = Math.round(s), p = r.type === "plp" && (() => {
    var j, N;
    const S = ((j = r.listId) == null ? void 0 : j.toLowerCase()) ?? "", I = ((N = r.listName) == null ? void 0 : N.toLowerCase()) ?? "";
    return S === "swipeable-product-list" || I === "swipeable product list" || S.includes("swipeable-product-list") || I.includes("swipeable product list");
  })(), v = !p, w = (e.swipeHint ?? !1) && !p && r.type === "plp" && r.position === 0;
  ht(i, w);
  const f = e.styling ?? Ye, L = C.useMemo(
    () => p ? { ...e.variants ?? {}, hoverEffect: "changeImage" } : e.variants,
    [p, e.variants]
  ), D = f.styles(L), k = v && ((fe = e.indicator) == null ? void 0 : fe.enabled) && ((o == null ? void 0 : o.length) ?? 0) > 1, y = v && ((ye = e.arrowNavigation) == null ? void 0 : ye.enabled) && ((o == null ? void 0 : o.length) ?? 0) > 1, re = 4, ie = r.type === "plp" && r.position < re, { isAtStart: H, isAtEnd: M } = bt(
    i,
    "[data-product-card-gallery]",
    [o == null ? void 0 : o.length, l]
  );
  C.useEffect(() => {
    if (!k || !i.current)
      return;
    const S = i.current.querySelector(
      "[data-product-card-gallery]"
    );
    if (!S)
      return;
    const I = () => {
      const j = S.scrollLeft, N = S.clientWidth, ce = j / N;
      c(ce);
    };
    return I(), S.addEventListener("scroll", I, { passive: !0 }), () => S.removeEventListener("scroll", I);
  }, [k, o == null ? void 0 : o.length]);
  const W = ({ direction: S }) => {
    if (u(!0), !i.current)
      return;
    const I = i.current.querySelector(
      "[data-product-card-gallery]"
    );
    if (!I)
      return;
    const N = I.clientWidth;
    I.scrollBy({
      left: S === "left" ? -N : N,
      top: 0,
      behavior: "smooth"
    });
  };
  if (!o)
    return null;
  const K = ((we = e.deferImages) == null ? void 0 : we.enabled) ?? !1, Y = ((ve = e.deferImages) == null ? void 0 : ve.initialCount) ?? g, se = !K || l ? o : o.slice(0, Y);
  return /* @__PURE__ */ m(
    "div",
    {
      className: O(e.className, D.wrapper),
      ref: i,
      role: "region",
      "aria-label": `Product images, ${(o == null ? void 0 : o.length) || 0} images`,
      "aria-roledescription": "carousel",
      onPointerEnter: d,
      onTouchStart: d,
      onFocus: d,
      children: [
        y && /* @__PURE__ */ m(T, { children: [
          /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              "aria-label": `Previous image${o && o.length > 1 ? `, currently showing image ${b + 1} of ${o.length}` : ""}`,
              className: D.leftArrow,
              onClick: () => W({ direction: "left" }),
              disabled: H,
              "aria-disabled": H,
              children: (Se = e.arrowNavigation) == null ? void 0 : Se.leftIcon
            }
          ),
          /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              "aria-label": `Next image${o && o.length > 1 ? `, currently showing image ${b + 1} of ${o.length}` : ""}`,
              className: D.rightArrow,
              onClick: () => W({ direction: "right" }),
              disabled: M,
              "aria-disabled": M,
              children: (Ie = e.arrowNavigation) == null ? void 0 : Ie.rightIcon
            }
          )
        ] }),
        /* @__PURE__ */ a(
          de,
          {
            productBase: n,
            context: "product-card",
            className: D.imageWrapper,
            "aria-label": `View ${n.content.name || "product"} details`,
            "data-product-card-gallery": !0,
            "data-multiple-images": (o == null ? void 0 : o.length) > 1 ? "true" : "false",
            role: "group",
            "aria-roledescription": "slide",
            children: se.map((S, I) => {
              const N = ie && I === 0, ce = N ? "eager" : "lazy", Re = N ? "high" : "auto";
              return /* @__PURE__ */ a(
                Te,
                {
                  displaySize: { mobile: "50vw", desktop: "25vw" },
                  image: { src: S.src, alt: S.alt },
                  className: D.image,
                  ...e.imageSettings,
                  loading: ce,
                  fetchpriority: Re,
                  "aria-label": `${S.alt || n.content.name || "Product image"} ${o.length > 1 ? `${I + 1} of ${o.length}` : ""}`
                },
                I
              );
            })
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            className: "sr-only",
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "true",
            children: o && o.length > 1 && `Viewing image ${b + 1} of ${o.length}`
          }
        ),
        k && /* @__PURE__ */ a(
          wt,
          {
            imagesCount: o.length,
            scrollPosition: s,
            type: (Ce = e.indicator) == null ? void 0 : Ce.type,
            slots: D
          }
        ),
        e.children
      ]
    }
  );
}), Q = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional(),
  discountBadge: t.object({
    enabled: t.boolean().optional(),
    variants: t.custom().optional()
  }).optional(),
  location: t.enum(["gallery", "details"]).optional().describe(
    "Where the component is placed in the DOM so we can make our magic swap"
  ),
  placeIn: t.enum(["gallery", "details"]).optional().describe("Where to place the badges in the DOM"),
  showWithDiscount: t.boolean().optional()
}), ee = P(
  "ProductCardBadges",
  h(
    {
      schema: Q,
      defaultProps: {
        location: "gallery",
        placeIn: "gallery",
        showWithDiscount: !0
      }
    },
    ({
      variants: e,
      location: n,
      placeIn: o,
      styling: r,
      discountBadge: i,
      className: s,
      showWithDiscount: c
    }) => {
      var w;
      const {
        content: { badges: l }
      } = B(), u = me(), d = z(), g = u.price.number < u.priceWithoutDiscount.number;
      if (n !== o)
        return;
      const p = (r ?? Ze).styles({
        ...e,
        placeIn: o ?? "gallery"
      }), v = (i == null ? void 0 : i.enabled) && g && !u.discountButNoCampaign;
      return !l.length && !v ? null : /* @__PURE__ */ m("div", { className: O(s, p.wrapper), children: [
        v && /* @__PURE__ */ a(
          $,
          {
            label: d("PLP_Discount_Badge", {
              saveAmount: u.priceWithoutDiscount.number - u.price.number,
              saveProcentage: `${(w = u.discountInfo) == null ? void 0 : w.percent}%`
            }),
            variants: i.variants
          }
        ),
        (c || !v) && l.map((f, L) => /* @__PURE__ */ a(
          "span",
          {
            className: p.badge,
            "data-type": f.badgeType,
            style: {
              ...f.backgroundColor && {
                backgroundColor: f.backgroundColor
              },
              ...f.textColor && { color: f.textColor }
            },
            children: d(f.label)
          },
          L
        ))
      ] });
    }
  )
), vt = ({ on: e }) => /* @__PURE__ */ m(T, { children: [
  /* @__PURE__ */ m("svg", { viewBox: "0 0 24 24", className: "overflow-visible w-7 h-7", children: [
    /* @__PURE__ */ a(
      "use",
      {
        xlinkHref: "#heart",
        className: lt(
          "fill-transparent transition-all stroke-1",
          e ? "stroke-transparent" : "stroke-gray-700"
        )
      }
    ),
    /* @__PURE__ */ a(dt, { initial: !1, children: e && /* @__PURE__ */ a(
      Be.use,
      {
        xlinkHref: "#heart",
        className: "fill-red-500 stroke-red-500 origin-center",
        initial: { opacity: 0, scale: 0.2 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.2 },
        transition: { duration: 0.5, ease: [0.19, 2.41, 0.45, 0.94] }
      }
    ) })
  ] }),
  /* @__PURE__ */ a("svg", { className: "hidden", viewBox: "0 0 512 512", children: /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a(
    "path",
    {
      id: "heart",
      d: "M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z"
    }
  ) }) })
] }), F = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  enabled: t.boolean().optional(),
  triggerIcon: t.union([t.string(), t.custom()]).optional()
}), Ta = h(F, (e) => {
  if (!e.enabled)
    return null;
  const n = Je.styles(e.variants), o = e.triggerIcon || /* @__PURE__ */ a(vt, { on: !1 });
  return /* @__PURE__ */ a("div", { className: e.className + " " + n.wrapper, children: o });
}), he = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional(),
  children: t.custom().optional()
}), We = h(he, (e) => {
  const n = B(), r = (e.styling ?? U).styles(e.variants);
  return /* @__PURE__ */ m("div", { className: r.detailsWrapper, children: [
    e.children,
    /* @__PURE__ */ a(
      de,
      {
        productBase: n,
        className: r.detailsLink,
        context: "product-card",
        "aria-label": "View product details"
      }
    )
  ] });
}), St = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional()
}), Ae = h(St, (e) => {
  const {
    content: { name: n }
  } = B(), r = (e.styling ?? U).styles(e.variants);
  return /* @__PURE__ */ a("h4", { className: r.name, children: n });
}), It = (e) => {
  var n, o, r;
  return /* @__PURE__ */ m(T, { children: [
    !e.isDiscounted && /* @__PURE__ */ a(
      $,
      {
        className: e.slots.price,
        label: e.priceInfo.price.formatted,
        ...(n = e.badge) == null ? void 0 : n.default
      }
    ),
    e.isDiscounted && /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ a(
        $,
        {
          className: e.slots.price,
          label: e.priceInfo.price.formatted,
          ...(o = e.badge) == null ? void 0 : o.discounted
        }
      ),
      /* @__PURE__ */ a(
        $,
        {
          className: e.slots.priceBeforeDiscount,
          label: e.priceInfo.priceWithoutDiscount.formatted,
          ...(r = e.badge) == null ? void 0 : r.default
        }
      )
    ] })
  ] });
}, Ct = (e) => /* @__PURE__ */ m(T, { children: [
  /* @__PURE__ */ a(
    "span",
    {
      "data-is-discounted": e.isDiscounted ? "true" : "false",
      className: e.slots.price,
      children: e.priceInfo.price.formatted
    }
  ),
  e.isDiscounted && /* @__PURE__ */ a("span", { className: e.slots.priceBeforeDiscount, children: e.priceInfo.priceWithoutDiscount.formatted })
] }), V = t.object({
  as: t.enum(["badge", "span"]).optional(),
  badge: t.object({
    default: J.optional(),
    discounted: J.optional()
  }).optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional()
}), ze = h(V, (e) => {
  const n = me();
  if (!n)
    return null;
  const r = (e.styling ?? U).styles(e.variants), i = n.price.number < n.priceWithoutDiscount.number, s = {
    priceInfo: n,
    isDiscounted: i,
    slots: r
  }, c = e.as ?? "span";
  return /* @__PURE__ */ m("div", { className: r.priceWrapper, children: [
    c === "badge" && /* @__PURE__ */ a(It, { ...s, badge: e.badge }),
    c === "span" && /* @__PURE__ */ a(Ct, { ...s })
  ] });
}), kt = (e) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(e), Dt = (e) => /^[a-zA-Z]+$/.test(e) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(e), Kt = (e) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(e) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(e), Nt = (e) => e.startsWith("http") || e.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(e), Pt = ({
  sibling: e,
  productSwatchAttribute: n,
  className: o
}) => {
  const r = B(), i = Ee(e);
  if (!e || !n)
    return null;
  const s = i(
    n,
    t.string()
  );
  if (!s)
    return null;
  const c = s.valueLabel, l = s.value, u = () => l ? Nt(l) ? {
    backgroundImage: `url(${l})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : kt(l) || Dt(l) || Kt(l) ? { backgroundColor: l } : { backgroundColor: "#cccccc" } : {};
  return /* @__PURE__ */ a(
    de,
    {
      productBase: e,
      className: o,
      context: "product-sibling",
      "aria-label": `Go to ${c} product`,
      "data-is-white": l === "#ffffff" || (c == null ? void 0 : c.toLocaleLowerCase()) === "white" || (c == null ? void 0 : c.toLocaleLowerCase()) === "vit",
      style: u(),
      "data-selected": r.productId === e.productId
    }
  );
}, R = t.object({
  className: t.string().optional(),
  variants: t.custom().optional().describe("Variants for the swatches"),
  productSwatchAttribute: t.string().optional().describe("What attribute to use for the swatch color"),
  maxSwatches: t.number().optional().describe(
    "Maximum number of swatches to display. Remaining count shown as +N."
  ),
  location: t.enum(["gallery", "details"]).optional().describe(
    "Where the component is placed in the DOM so we can make our magic swap"
  ),
  placeIn: t.enum(["gallery", "details"]).optional().describe("Where to place the swatches in the DOM")
}), te = P(
  "ProductCardSwatches",
  h(
    {
      schema: R,
      defaultProps: {
        productSwatchAttribute: "colorSwatchHex",
        placeIn: "gallery"
      }
    },
    (e) => {
      if (e.location !== e.placeIn)
        return;
      const n = it(), o = et.styles({
        ...e.variants,
        placeIn: e.placeIn ?? "gallery"
      });
      if (!n.length)
        return null;
      const r = e.maxSwatches != null ? n.slice(0, e.maxSwatches) : n, i = n.length - r.length;
      return /* @__PURE__ */ a("div", { className: O(e.className, o.wrapper), children: /* @__PURE__ */ m("div", { className: o.swatches, children: [
        r.map((s) => /* @__PURE__ */ a(
          Pt,
          {
            sibling: s,
            productSwatchAttribute: e.productSwatchAttribute,
            className: o.swatch
          },
          s.productId
        )),
        i > 0 && /* @__PURE__ */ m("span", { className: o.overflow, children: [
          "+",
          i
        ] })
      ] }) });
    }
  )
), be = t.object({
  variants: t.custom().optional(),
  styling: t.custom().optional(),
  dataKey: t.literal("shortDescription").optional(),
  attributeKey: t.string().optional()
}), Et = h(be, (e) => {
  var c;
  const n = B(), o = Ee(n);
  let r;
  e.dataKey && (r = n.content[e.dataKey]), e.attributeKey && (r = (c = o(e.attributeKey, t.string())) == null ? void 0 : c.value);
  const s = (e.styling ?? U).styles(e.variants);
  return r ? /* @__PURE__ */ a("p", { className: s.productInfoText, children: r }) : null;
}), xt = t.object({
  option: t.custom(),
  optionGroup: t.custom(),
  className: t.string().optional(),
  buttons: q.optional(),
  postAddAction: t.union([t.literal("showMinicart"), t.literal("none")]).optional().describe("Action to perform after adding the product to the cart"),
  action: t.union([t.literal("addToCart"), t.literal("selectOption")]).optional()
}), je = P(
  "QuickshopButton",
  h(
    xt,
    ({ buttons: e, option: n, className: o, optionGroup: r, action: i, postAddAction: s }) => {
      var f;
      const { quickAddToCartMethod: c } = gt(), { selectOption: l, optionGroups: u, selectedOptions: d } = X(), g = typeof window < "u" && window.location.pathname.includes("/checkout"), p = u.length > 1 || i === "selectOption" ? () => l(r.dimensionKey, n) : n.inventory.inStock ? () => c.execute(n).then(() => {
        s === "showMinicart" && !g && A.emit("open", {
          overlayId: "mini-cart"
        });
      }) : () => l(r.dimensionKey, n), v = ((f = d[r.dimensionKey]) == null ? void 0 : f.dimensionValue) === n.dimensionValue, w = !n.inventory.inStock;
      return /* @__PURE__ */ a(
        G,
        {
          onClick: p,
          className: o,
          label: n.label,
          progress: c.loadingState,
          dataAttr: {
            "is-selected": !!v,
            "appear-disabled": !!w,
            "is-out-of-stock": !!w
          },
          ...e
        },
        n.label
      );
    }
  )
), _e = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  buttons: q.optional(),
  postAddAction: t.union([t.literal("showMinicart"), t.literal("none")]).optional().describe("Action to perform after adding the product to the cart")
}), Tt = P(
  "ProductCardQuickshopButtonGrid",
  h(
    {
      schema: _e,
      defaultProps: {
        template: "button-grid",
        buttons: {
          variants: {
            style: "transparent",
            color: "secondary",
            size: "sm"
          }
        }
      }
    },
    ({ variants: e, buttons: n, postAddAction: o }) => {
      const r = tt.styles(e), i = X();
      return pe(), /* @__PURE__ */ a("div", { className: r.base, children: i.optionGroups.map((s) => /* @__PURE__ */ a("div", { className: r.wrapper, children: s.options.map((c, l) => /* @__PURE__ */ a(
        je,
        {
          postAddAction: o,
          option: c,
          optionGroup: s,
          className: r.size,
          buttons: n
        },
        `${c.label}-${l}`
      )) }, s.dimensionKey)) });
    }
  )
), Bt = () => /* @__PURE__ */ m(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ a("defs", {}),
      /* @__PURE__ */ a("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), Lt = () => /* @__PURE__ */ m(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ a("defs", {}),
      /* @__PURE__ */ a("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), Oe = t.object({
  variants: t.custom().optional(),
  incrementWith: t.number().optional().describe("The number to increment with"),
  inputFieldIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional(),
  plusButtonVariants: t.any().optional().describe("Variants for the plus button"),
  minusButtonVariants: t.any().optional()
}), He = t.object({
  template: t.literal("increment"),
  variants: t.custom().optional(),
  increments: t.array(Oe).optional(),
  // Solve the issue with error TS7056: The inferred type of this node exceeds the maximum length the compiler will serialize. An explicit type annotation is needed.
  plusButtonVariants: t.any().optional().describe("Variants for the plus button"),
  minusButtonVariants: t.any().optional()
}), Wt = h(
  Oe,
  ({
    incrementWith: e = 1,
    inputFieldIcon: n,
    minusButtonVariants: o,
    plusButtonVariants: r,
    variants: i
  }) => {
    const s = Ne.styles(i), c = z(), {
      quantityInCart: l,
      addToCartMethod: u,
      removeFromCartMethod: d,
      isAvailable: g
    } = ne(), b = () => typeof n == "string" || Xe(n) ? n : typeof n == "function" ? /* @__PURE__ */ a(n, {}) : null;
    return /* @__PURE__ */ m("div", { className: s.container, children: [
      /* @__PURE__ */ a(
        G,
        {
          progress: d.loadingState,
          iconLeft: /* @__PURE__ */ a(Bt, {}),
          variants: o,
          disabled: l < e,
          onClick: () => d.execute(e)
        }
      ),
      /* @__PURE__ */ m("div", { className: s.inputFieldWrapper, children: [
        n && /* @__PURE__ */ a("span", { className: s.inputFieldIcon, children: b() }),
        /* @__PURE__ */ a("span", { className: s.inputField, children: e }),
        /* @__PURE__ */ a("span", { className: s.numberSuffix, children: c("Quickshop_Increment_Number_Suffix") })
      ] }),
      /* @__PURE__ */ a(
        G,
        {
          progress: u.loadingState,
          iconLeft: /* @__PURE__ */ a(Lt, {}),
          variants: r,
          onClick: () => u.execute(e),
          disabled: !g
        }
      )
    ] }, `increment-${e}`);
  }
), At = h(He, (e) => {
  const n = Ne.styles(e.variants), o = (e == null ? void 0 : e.increments) || [
    {
      incrementWith: 1
    }
  ];
  return /* @__PURE__ */ a("div", { className: n.wrapper, children: o.map((r, i) => /* @__PURE__ */ Ue(Wt, { ...r, ...e, key: i })) });
}), Me = t.object({
  template: t.literal("dropdown-on-hover"),
  variants: t.custom().optional()
}), zt = h(
  Me,
  ({ variants: e }) => {
    const n = X();
    return at.styles(e), /* @__PURE__ */ a("div", { className: "absolute flex z-30 group-hover:translate-y-0 translate-y-full bottom-0 transition-transform duration-300 left-0 right-0 bg-page-surface", children: n.optionGroups.map((o) => /* @__PURE__ */ a(
      "div",
      {
        className: "grid grid-cols-5 px-4 py-2 w-full",
        children: o.options.map((r) => /* @__PURE__ */ a(
          "button",
          {
            onClick: () => console.log(r.label),
            className: "text-black cols-span-1 text-sm py-2 hover:bg-white",
            children: r.label
          }
        ))
      },
      o.dimensionKey
    )) });
  }
), jt = {
  available: "PLP_Add_To_Cart",
  "out-of-stock": "PLP_Out_Of_Stock",
  discontinued: "PLP_Discontinued",
  "not-determined": "PLP_Select_Size"
}, $e = () => {
  const e = oe(), n = z(), o = jt[e.status] ?? "PLP_Select_Size";
  return n(o);
}, _t = {
  width: "full",
  color: "primary"
}, qe = t.object({
  template: t.literal("one-size-button"),
  variants: t.custom().optional().describe("Variants for the one size button"),
  buttonVariants: mt.shape.variants.optional().describe("Variants for the button")
}), Ot = P(
  "OneSizeButton",
  h(
    qe,
    ({ variants: e, buttonVariants: n = _t }) => {
      const o = ot.styles(e), { addToCartMethod: r, isAvailable: i } = ne(), c = oe().status === "out-of-stock", l = z(), u = $e(), d = async () => {
        if (c) {
          ke.error(l("PLP_Add_To_Cart_Error_Out_Of_Stock_Toast"));
          return;
        }
        if (!i) {
          ke.error(l("PLP_Add_To_Cart_Error_Not_Available_Toast"));
          return;
        }
        try {
          await r.execute();
        } catch (g) {
          console.error(g);
        }
      };
      return /* @__PURE__ */ a(
        "div",
        {
          className: o.base,
          "data-is-out-of-stock": c ? "true" : "false",
          children: /* @__PURE__ */ a(
            G,
            {
              onClick: d,
              label: u,
              progress: r.loadingState,
              dataAttr: { "appear-disabled": c },
              variants: n
            }
          )
        }
      );
    }
  )
), Ht = {
  direction: "bottom",
  variants: {
    rounded: "subtle"
  }
}, Ge = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional().describe("Variants for the drawer"),
  displayHeading: t.boolean().optional().describe("Display the title of the drawer"),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttons: q.optional(),
  addToCartButton: q.optional(),
  oneSizeButton: q.optional(),
  alwaysDisplayAddToCartButton: t.boolean().optional().describe("Always display the add to cart button"),
  showWhenOutOfStock: t.boolean().optional().describe(
    "Show the quickshop trigger even when out of stock (for back-in-stock functionality)"
  ),
  postAddAction: t.union([
    t.literal("showMinicart"),
    t.literal("closeDrawer"),
    t.literal("none")
  ]).optional().describe(
    "Action to perform after adding the product to the cart or closing the drawer"
  ),
  trigger: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional().describe(
    "The trigger for the drawer, can be a string, a component or an element"
  ),
  aboveAddToCartButtonComponent: t.custom().optional(),
  belowAddToCartButtonComponent: t.custom().optional(),
  wrapper: t.custom().optional().describe(
    "A component that wraps the entire drawer. Receives { children, isOpen }"
  )
}), Mt = () => {
  const [e, n] = Z(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return Ke(() => {
    const o = () => {
      n(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", o), () => window.removeEventListener("resize", o);
  }, []), e;
}, $t = ({
  variants: e,
  displayHeading: n,
  buttons: o,
  addToCartButton: r,
  alwaysDisplayAddToCartButton: i,
  showWhenOutOfStock: s,
  postAddAction: c,
  aboveAddToCartButtonComponent: l,
  belowAddToCartButtonComponent: u
}) => {
  const d = B(), g = Pe(), b = X(), { addToCartMethod: p, isOutOfStock: v } = ne(), w = me(), f = $e(), L = oe(), D = pe(), k = z(), y = ue.styles(e), re = typeof window < "u" && window.location.pathname.includes("/checkout"), ie = async () => {
    if (!v) {
      try {
        await p.execute();
      } catch (K) {
        console.error("Error adding to cart:", K);
        return;
      }
      c === "showMinicart" && !re && (A.emit("close", { overlayId: "quickshop-drawer" }), setTimeout(() => {
        A.emit("open", { overlayId: "mini-cart" });
      }, 300)), c === "closeDrawer" && A.emit("close", { overlayId: "quickshop-drawer" });
    }
  }, H = g == null ? void 0 : g[0], M = w.price.number < w.priceWithoutDiscount.number, W = b.optionGroups.length > 1;
  return !D && !s ? null : /* @__PURE__ */ m(
    "div",
    {
      className: y.baseWrapper,
      "data-has-multiple-options": W ? "true" : "false",
      children: [
        n && /* @__PURE__ */ a("div", { className: y.header, children: /* @__PURE__ */ a("h3", { className: y.heading, children: k("Quickshop_Drawer_Heading") }) }),
        /* @__PURE__ */ m("div", { className: y.productInfo, children: [
          H && /* @__PURE__ */ a(Te, { className: y.productImage, image: H }),
          /* @__PURE__ */ a("h4", { className: y.productName, children: d.content.name }),
          /* @__PURE__ */ m("div", { className: y.productPriceWrapper, children: [
            /* @__PURE__ */ a(
              "span",
              {
                "data-is-discounted": M ? "true" : "false",
                className: y.productPrice,
                children: w.price.formatted
              }
            ),
            M && /* @__PURE__ */ a("span", { className: y.productPriceBeforeDiscount, children: w.priceWithoutDiscount.formatted })
          ] })
        ] }),
        /* @__PURE__ */ a("div", { className: y.optionGroupsWrapper, children: b.optionGroups.map((K) => /* @__PURE__ */ m(
          "div",
          {
            className: y.wrapper,
            "data-dimension-key": K.dimensionKey,
            "data-dimension-label": K.dimensionLabel,
            children: [
              /* @__PURE__ */ a("span", { className: y.sizeLabel, children: k(W ? `Size_Picker_${K.dimensionLabel}` : "Quickshop_Select_Size") }),
              /* @__PURE__ */ a("div", { className: y.sizes, children: K.options.map((Y, se) => /* @__PURE__ */ a(
                je,
                {
                  option: Y,
                  optionGroup: K,
                  className: y.size,
                  action: W || i ? "selectOption" : "addToCart",
                  buttons: o
                },
                `${Y.label}-${se}`
              )) })
            ]
          },
          K.dimensionKey
        )) }),
        l,
        (W || i) && /* @__PURE__ */ a(
          pt,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...r,
            progress: p.loadingState,
            dataAttr: {
              "appear-disabled": L.status !== "available"
            },
            disabled: L.status !== "available",
            label: f,
            onClick: ie,
            className: y.addToCartButton
          }
        ),
        u
      ]
    }
  );
}, qt = (e) => {
  const {
    variants: n,
    displayHeading: o,
    drawerSettings: r,
    trigger: i,
    buttons: s,
    addToCartButton: c,
    alwaysDisplayAddToCartButton: l,
    showWhenOutOfStock: u,
    postAddAction: d,
    aboveAddToCartButtonComponent: g,
    onDrawerOpenChange: b,
    wrapper: p,
    isOpen: v
  } = e, w = Mt(), f = ue.styles(n);
  if (!pe() && !u)
    return null;
  const D = () => typeof i == "string" || C.isValidElement(i) ? i : typeof i == "function" ? /* @__PURE__ */ a(i, {}) : null;
  return /* @__PURE__ */ m(
    le,
    {
      customOverlayId: "quickshop-drawer",
      ...r,
      direction: w ? "right" : "bottom",
      onOpenChange: b,
      variants: (r == null ? void 0 : r.variants) && {
        ...r.variants,
        ...w ? { direction: "right" } : { direction: "bottom" }
      },
      children: [
        /* @__PURE__ */ a(
          le.Trigger,
          {
            className: f.trigger,
            "data-is-one-size": "false",
            "aria-label": "Open quickshop drawer",
            children: D()
          }
        ),
        /* @__PURE__ */ a(le.Content, { children: (() => {
          const k = /* @__PURE__ */ a($t, { ...e });
          return p ? /* @__PURE__ */ a(p, { isDrawerOpen: v, children: k }) : k;
        })() })
      ]
    }
  );
}, Gt = (e) => {
  const { variants: n, trigger: o, postAddAction: r, oneSizeButton: i } = e, s = ue.styles(n), { addToCartMethod: c, isOutOfStock: l } = ne(), [u, d] = Z(!1), [g, b] = Z(!1), p = typeof window < "u" && window.location.pathname.includes("/checkout"), v = async () => {
    if (!l) {
      try {
        d(!0), await c.execute(), b(!0), setTimeout(() => {
          d(!1), b(!1);
        }, 1e3);
      } catch (f) {
        console.error("Error adding to cart:", f), d(!1), b(!1);
        return;
      }
      r === "showMinicart" && !p && (A.emit("close", { overlayId: "quickshop-drawer" }), setTimeout(() => {
        A.emit("open", { overlayId: "mini-cart" });
      }, 300)), r === "closeDrawer" && A.emit("close", { overlayId: "quickshop-drawer" });
    }
  }, w = () => typeof o == "string" || C.isValidElement(o) ? o : typeof o == "function" ? /* @__PURE__ */ a(o, {}) : null;
  return /* @__PURE__ */ a("span", { className: s.trigger, "data-is-one-size": "true", children: /* @__PURE__ */ a(
    G,
    {
      variants: {
        color: "white",
        rounded: "md",
        size: "sm"
      },
      dataAttr: {
        "is-on-size": "true"
      },
      ariaLabel: "Add to cart",
      onClick: v,
      disabled: u,
      progress: g ? "complete" : u ? "loading" : "default",
      label: w(),
      ...i
    }
  ) });
}, Qt = P(
  "QuickshopDrawer",
  h(
    {
      schema: Ge,
      defaultProps: {
        template: "drawer",
        drawerSettings: Ht,
        buttons: {
          variants: {
            style: "outline",
            color: "primary",
            rounded: "md",
            size: "sm"
          }
        },
        displayHeading: !0,
        postAddAction: "none",
        alwaysDisplayAddToCartButton: !1,
        showWhenOutOfStock: !1
      }
    },
    (e) => {
      const n = xe(), [o, r] = Z(!1);
      if (n === "with_variants")
        return /* @__PURE__ */ a(
          qt,
          {
            ...e,
            onDrawerOpenChange: r,
            isOpen: o
          }
        );
      if (n === "simple")
        return /* @__PURE__ */ a(Gt, { ...e });
    }
  )
), Qe = t.discriminatedUnion("template", [
  _e,
  Me,
  qe,
  Ge,
  He
]), Fe = h(Qe, (e) => {
  switch (e.template) {
    case "button-grid":
      return /* @__PURE__ */ a(Tt, { ...e });
    case "dropdown-on-hover":
      return /* @__PURE__ */ a(zt, { ...e });
    case "one-size-button":
      return /* @__PURE__ */ a(Ot, { ...e });
    case "drawer":
      return /* @__PURE__ */ a(Qt, { ...e });
    case "increment":
      return /* @__PURE__ */ a(At, { ...e });
    default:
      return null;
  }
}), Ft = t.object({
  sizesCount: t.object({
    from: t.number(),
    to: t.number()
  }).describe(
    "If a product has the number of sizes specified as a range, show the supplied template"
  ),
  optionsCount: t.object({
    from: t.number(),
    to: t.number()
  }).describe(
    "If a product has the number of options specified as a range, show the supplied template"
  )
});
function De(e, n) {
  const o = e.map((s) => s.options.length);
  o.sort();
  const r = o[o.length - 1];
  if (typeof r > "u")
    return !1;
  const i = e.length;
  return r >= n.sizesCount.from && r <= n.sizesCount.to && i >= n.optionsCount.from && i <= n.optionsCount.to;
}
const Vt = {
  "button-grid": {
    sizesCount: {
      from: 2,
      to: 10
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  "dropdown-on-hover": {
    sizesCount: {
      from: 2,
      to: 10
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  "one-size-button": {
    sizesCount: {
      from: 0,
      to: 1
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  drawer: {
    sizesCount: {
      from: 1,
      to: 20
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  increment: {
    sizesCount: {
      from: 0,
      to: 10
    },
    optionsCount: {
      from: 0,
      to: 5
    }
  }
}, Rt = t.object({
  config: Ft,
  template: Qe
}), x = t.object({
  configs: t.array(Rt).optional().describe("The configuration for the quickshop")
}), ae = (e) => {
  const n = xe();
  switch (n) {
    case "with_variants":
      return /* @__PURE__ */ a(Ut, { configs: e.configs });
    case "simple":
      return /* @__PURE__ */ a(Xt, { configs: e.configs });
    case "bundle":
      return null;
    default:
      return console.error(`Unknown product data model "${n}"`), null;
  }
}, Ut = (e) => {
  var r;
  const { optionGroups: n } = X(), o = (r = e.configs) == null ? void 0 : r.filter(
    (i) => (
      // First, check that the template supports the product options
      De(
        n,
        Vt[i.template.template]
      ) && // Then, check that the supplied config supports the product options
      De(n, i.config)
    )
  );
  return !o || o.length === 0 ? null : /* @__PURE__ */ a(T, { children: o.map((i, s) => /* @__PURE__ */ a(Fe, { ...i.template }, s)) });
}, Xt = (e) => {
  var o;
  const n = (o = e.configs) == null ? void 0 : o.filter(
    (r) => r.config.sizesCount.from <= 1
  );
  return !n || n.length === 0 ? null : /* @__PURE__ */ a(T, { children: n.map((r, i) => /* @__PURE__ */ a(Fe, { ...r.template }, i)) });
}, Yt = {
  configs: [
    {
      config: {
        sizesCount: {
          from: 2,
          to: 10
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "button-grid",
        variants: {
          placeIn: "gallery"
        }
      }
    },
    {
      config: {
        sizesCount: {
          from: 2,
          to: 20
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "drawer",
        variants: {
          placeIn: "gallery"
        }
      }
    },
    {
      config: {
        sizesCount: {
          from: 0,
          to: 1
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "one-size-button",
        variants: {
          placeIn: "gallery"
        }
      }
    }
  ]
}, Zt = {
  configs: [
    {
      config: {
        sizesCount: {
          from: 0,
          to: 1
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "one-size-button",
        variants: {
          placeIn: "details"
        }
      }
    }
  ]
}, Jt = {
  gallery: Yt,
  details: Zt
}, ea = t.object({
  blueprint: t.custom().optional(),
  /**
   * The template to use for the product card component (default is "1")
   */
  template: t.literal("1"),
  variants: t.custom().optional(),
  productInfoText: be.optional(),
  /**
   * Gallery configuration
   */
  gallery: ge.optional().describe("Details configuration"),
  /**
   * Details configuration
   */
  details: he.optional().describe("Details configuration"),
  /**
   * Badges configuration
   */
  badges: Q.omit({ location: !0 }).optional().describe("Badges configuration"),
  /**
   * Swatches configuration
   */
  swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
  /**
   * Quickshop configuration
   */
  quickshop: t.object({
    gallery: x.optional(),
    details: x.optional()
  }).optional().describe("Quickshop configuration"),
  /**
   * Price configuration
   */
  price: V.omit({ variants: !0, styling: !0 }).optional().describe("Price configuration"),
  wishlist: F.optional().describe("Wishlist configuration"),
  /**
   * Reviews configuration
   */
  reviewStarsSlot: t.custom().optional().describe("Reviews configuration")
}), ta = P(
  "ProductCardTemplate1",
  h(
    {
      schema: ea,
      defaultProps: {
        template: "1",
        quickshop: Jt
      }
    },
    ({
      badges: e,
      variants: n,
      price: o,
      quickshop: r,
      swatches: i,
      blueprint: s,
      details: c,
      productInfoText: l,
      gallery: u,
      reviewStarsSlot: d
    }) => {
      const b = (s ?? _).main.styles(n), p = st();
      return /* @__PURE__ */ m("div", { className: b.wrapper, children: [
        /* @__PURE__ */ m(Le, { styling: _.gallery, ...u, children: [
          /* @__PURE__ */ a(ee, { ...e, location: "gallery" }),
          /* @__PURE__ */ a(te, { ...i, location: "gallery" }),
          !p && /* @__PURE__ */ a(ae, { ...r == null ? void 0 : r.gallery })
        ] }),
        /* @__PURE__ */ m(We, { styling: _.details, ...c, children: [
          d,
          /* @__PURE__ */ a(Ae, { styling: _.details }),
          /* @__PURE__ */ a(
            ze,
            {
              ...o,
              styling: _.details,
              variants: c == null ? void 0 : c.variants
            }
          ),
          /* @__PURE__ */ a(
            Et,
            {
              styling: _.details,
              ...l
            }
          ),
          /* @__PURE__ */ a(te, { ...i, location: "details" }),
          /* @__PURE__ */ a(ee, { ...e, location: "details" }),
          !p && /* @__PURE__ */ a(ae, { ...r == null ? void 0 : r.details })
        ] })
      ] });
    }
  )
), aa = t.object({
  variants: t.custom().optional(),
  styling: t.custom().optional()
}), oa = h(aa, (e) => {
  const {
    content: { shortDescription: n }
  } = B(), r = (e.styling ?? U).styles(e.variants);
  return n ? /* @__PURE__ */ a("p", { className: r.shortDescription, children: n }) : null;
}), na = {
  details: {
    configs: [
      {
        config: {
          sizesCount: {
            from: 0,
            to: 1
          },
          optionsCount: {
            from: 0,
            to: 1
          }
        },
        template: { template: "increment" }
      }
    ]
  }
}, Ba = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), ra = t.object({
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional()
}), ia = P(
  "AttributesAsProgressBar",
  h(
    ra,
    ({
      variants: e,
      features: n = {
        onAScaleOf: 10
      }
    }) => {
      const o = z(), r = nt.styles(e), i = ct(
        "progress-bar",
        t.string()
      );
      return i != null && i.value ? /* @__PURE__ */ a("div", { className: r.base, children: /* @__PURE__ */ m("div", { className: r.item, children: [
        /* @__PURE__ */ a("div", { className: r.bar, children: /* @__PURE__ */ a(
          Be.div,
          {
            className: r.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${parseInt(i.value) / n.onAScaleOf * 100}%`
            },
            exit: { width: 0 }
          }
        ) }),
        /* @__PURE__ */ a("span", { className: r.label, children: o(i == null ? void 0 : i.attributeLabel) })
      ] }) }) : null;
    }
  )
), sa = t.object({
  /**
   * The template to use for the product card component (default is "default")
   */
  template: t.literal("2"),
  variants: t.custom().optional(),
  /**
   * Badges configuration
   */
  badges: Q.optional().describe("Badges configuration"),
  /**
   * Swatches configuration
   */
  swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
  /**
   * Quickshop configuration
   */
  quickshop: t.object({
    gallery: x.optional(),
    details: x.optional()
  }).optional().describe("Quickshop configuration"),
  /**
   * Price configuration
   */
  price: V.optional().describe("Price configuration"),
  wishlist: F.optional().describe("Wishlist configuration"),
  outOfStock: t.object({
    badge: J.optional(),
    text: t.string().optional()
  }).optional()
}), ca = h(
  {
    schema: sa,
    defaultProps: {
      template: "2"
    }
  },
  ({
    badges: e,
    variants: n,
    price: o,
    quickshop: r = na,
    swatches: i,
    outOfStock: s
  }) => {
    const { status: c } = oe(), l = z(), u = E.main.styles(n);
    return /* @__PURE__ */ m("div", { className: u.wrapper, children: [
      /* @__PURE__ */ m(Le, { styling: E.gallery, children: [
        /* @__PURE__ */ a(
          ee,
          {
            ...e,
            location: "gallery",
            styling: E.badges
          }
        ),
        /* @__PURE__ */ a(ia, {}),
        /* @__PURE__ */ a(te, { ...i, location: "gallery" }),
        /* @__PURE__ */ a(ze, { styling: E.details, ...o }),
        /* @__PURE__ */ a(ae, { ...r == null ? void 0 : r.gallery }),
        c === "out-of-stock" && /* @__PURE__ */ a("div", { className: u.outOfStockBadge, children: /* @__PURE__ */ a(
          $,
          {
            label: l("ProductCard_Out_Of_Stock_Badge"),
            ...s == null ? void 0 : s.badge
          }
        ) })
      ] }),
      /* @__PURE__ */ m(We, { styling: E.details, children: [
        /* @__PURE__ */ a(
          ee,
          {
            ...e,
            location: "details",
            styling: E.badges
          }
        ),
        /* @__PURE__ */ a(Ae, { styling: E.details }),
        /* @__PURE__ */ a(oa, { styling: E.details }),
        /* @__PURE__ */ a(te, { ...i, location: "details" }),
        /* @__PURE__ */ a(ae, { ...r == null ? void 0 : r.details })
      ] })
    ] });
  }
), Ve = t.discriminatedUnion(
  "template",
  [
    // Template 1
    t.object({
      template: t.literal("1"),
      variants: t.custom().optional(),
      /**
       * Details configuration
       */
      details: he.optional().describe("Details configuration"),
      productInfoText: be.optional(),
      /**
       * Gallery configuration
       */
      gallery: ge.optional().describe("Gallery configuration"),
      /**
       * Badges configuration
       */
      badges: Q.omit({ location: !0 }).optional().describe("Badges configuration"),
      /**
       * Swatches configuration
       */
      swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
      /**
       * Quickshop configuration
       */
      quickshop: t.object({
        gallery: x.optional(),
        details: x.optional()
      }).optional().describe("Quickshop configuration"),
      /**
       * Price configuration
       */
      price: V.omit({ variants: !0, styling: !0 }).optional().describe("Price configuration"),
      wishlist: F.optional().describe("Wishlist configuration"),
      /**
       * Reviews configuration
       */
      reviewStarsSlot: t.custom().optional().describe("Reviews configuration")
    }),
    // Template 2
    t.object({
      /**
       * The template to use for the product card component (default is "default")
       */
      template: t.literal("2"),
      variants: t.custom().optional(),
      /**
       * Badges configuration
       */
      badges: Q.optional().describe("Badges configuration"),
      /**
       * Swatches configuration
       */
      swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
      /**
       * Quickshop configuration
       */
      quickshop: t.object({
        gallery: x.optional(),
        details: x.optional()
      }).optional().describe("Quickshop configuration"),
      /**
       * Price configuration
       */
      price: V.optional().describe("Price configuration"),
      wishlist: F.optional().describe("Wishlist configuration"),
      outOfStock: t.object({
        badge: J.optional(),
        text: t.string().optional()
      }).optional()
    })
  ]
), la = h(
  Ve,
  (e) => {
    switch (e.template) {
      case "1":
        return /* @__PURE__ */ a(ta, { ...e });
      case "2":
        return /* @__PURE__ */ a(ca, { ...e });
      default:
        return null;
    }
  }
), ua = "1", da = t.object({
  templateProps: Ve.optional()
}), La = P(
  "ProductCard",
  h(da, (e) => {
    const n = e.templateProps || { template: ua };
    return /* @__PURE__ */ a(la, { ...n });
  })
), ma = t.object({
  from: t.number(),
  to: t.number()
}).describe("In what size range should the quickshop be shown"), Wa = t.object({
  /**
   * In between what sizes should the quickshop be shown.
   */
  sizeRange: ma.optional()
}), Aa = {
  dataModel: "with_variants",
  base: {
    productId: "1234",
    productKey: "1234",
    slug: "product",
    discontinued: !1,
    content: {
      name: "6090",
      description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
      shortDescription: "New Balance",
      media: [
        {
          type: "image",
          src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
          alt: "Image 1"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
          alt: "Image 2"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 3"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 4"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 5"
        }
      ],
      badges: [
        {
          label: "New In",
          badgeType: "new",
          backgroundColor: "#ffffff",
          textColor: "#000000",
          imageSrc: "https://example.com/badge1.png"
        },
        {
          label: "Sale",
          badgeType: "sale",
          backgroundColor: "#00000000",
          textColor: "#000000"
        }
      ]
    },
    attributes: [],
    categories: [
      {
        name: "Category 1",
        slug: "category1",
        categoryId: "cat1"
      },
      {
        name: "Category 2",
        slug: "category1/category2",
        categoryId: "cat2"
      }
    ]
  },
  siblingProducts: [
    {
      productId: "1234",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#161316"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1234551",
      productKey: "1243123",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#605960"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1236",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#FE673E"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "12348",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#D0D0D0"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    }
  ],
  variants: [
    {
      label: "XXL",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-07-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-1",
      variantKey: "v-1",
      sku: "sku-1",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "XXL",
          valueLabel: "XXL"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    {
      label: "S",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-07-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-1",
      variantKey: "v-1",
      sku: "sku-1",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "S",
          valueLabel: "S"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    {
      label: "XS",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-07-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-1",
      variantKey: "v-1",
      sku: "sku-1",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "XS",
          valueLabel: "XS"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    }
  ]
}, za = {
  dataModel: "with_variants",
  base: {
    productId: "1234",
    productKey: "1234",
    slug: "product",
    discontinued: !1,
    content: {
      name: "6090",
      description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
      shortDescription: "New Balance",
      media: [
        {
          type: "image",
          src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
          alt: "Image 1"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
          alt: "Image 2"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 3"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 4"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 5"
        }
      ],
      badges: [
        {
          label: "New In",
          badgeType: "new",
          backgroundColor: "#ffffff",
          textColor: "#000000",
          imageSrc: "https://example.com/badge1.png"
        },
        {
          label: "Sale",
          badgeType: "sale",
          backgroundColor: "#ffffff",
          textColor: "#000000"
        }
      ]
    },
    attributes: [],
    categories: [
      {
        name: "Category 1",
        slug: "category1",
        categoryId: "cat1"
      },
      {
        name: "Category 2",
        slug: "category1/category2",
        categoryId: "cat2"
      }
    ]
  },
  siblingProducts: [
    {
      productId: "1234",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#161316"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1234551",
      productKey: "1243123",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#605960"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1236",
      productKey: "1243131",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#FE673E"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "12348",
      productKey: "1246",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#D0D0D0"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    }
  ],
  variants: [
    {
      label: "38",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-38",
      variantKey: "v-38",
      sku: "sku-38",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "38",
          valueLabel: "38"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    {
      label: "39",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-39",
      variantKey: "v-39",
      sku: "sku-39",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "39",
          valueLabel: "39"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    // Continue with sizes 40 to 45 following the same pattern
    {
      label: "40",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-40",
      variantKey: "v-40",
      sku: "sku-40",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "40",
          valueLabel: "40"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "41",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-41",
      variantKey: "v-41",
      sku: "sku-41",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "41",
          valueLabel: "41"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "42",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-42",
      variantKey: "v-42",
      sku: "sku-42",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "42",
          valueLabel: "42"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "43",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-43",
      variantKey: "v-43",
      sku: "sku-43",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "43",
          valueLabel: "43"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "44",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-44",
      variantKey: "v-44",
      sku: "sku-44",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "44",
          valueLabel: "44"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "45",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-45",
      variantKey: "v-45",
      sku: "sku-45",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "45",
          valueLabel: "45"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "46",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-45",
      variantKey: "v-45",
      sku: "sku-45",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "45",
          valueLabel: "45"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "47",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-45",
      variantKey: "v-45",
      sku: "sku-45",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "45",
          valueLabel: "45"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    }
  ]
}, ja = {
  dataModel: "with_variants",
  base: {
    slug: "product-slug",
    productId: "product-id",
    productKey: "product-key",
    discontinued: !1,
    content: {
      name: "6090",
      description: "",
      shortDescription: "",
      media: [
        {
          type: "image",
          src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
          alt: "Image 1"
        }
      ],
      badges: []
    },
    attributes: [],
    categories: []
  },
  variants: [
    {
      dimensions: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: []
      },
      label: "variant label",
      mainProductId: "product-id",
      mainProductKey: "product-key",
      variantId: "variant-id",
      variantKey: "variant-key",
      sku: "sku",
      inventory: {
        quantity: 100,
        inStock: !0,
        warehouseId: "1"
      },
      additionalInventory: []
    }
  ],
  siblingProducts: []
}, _a = {
  dataModel: "simple",
  isBundle: !1,
  inventory: {
    quantity: 10,
    inStock: !0,
    warehouseId: "wh-1"
  },
  priceInfo: {
    price: { formatted: "1000 SEK", number: 1e3 },
    priceWithoutDiscount: {
      formatted: "1 0000 SEK",
      number: 1e4
    },
    previouslyDiscountedPrices: [
      {
        date: /* @__PURE__ */ new Date("2024-08-01"),
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        }
      },
      {
        date: /* @__PURE__ */ new Date("2024-07-01"),
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        }
      }
    ]
  },
  sku: "sku-38",
  additionalInventory: [],
  itemId: "item-onesize",
  base: {
    productId: "1234",
    productKey: "1234",
    slug: "product",
    discontinued: !1,
    content: {
      name: "Gaut Messenger Bag",
      description: "",
      shortDescription: "Klättermusen",
      media: [
        {
          type: "image",
          src: "https://i.ibb.co/hdwRqvS/40460-U21-587-01-51766.jpg",
          alt: "Image 1"
        },
        {
          type: "image",
          src: "https://i.ibb.co/CHhNxRv/40460-U21-587-02-24628.jpg",
          alt: "Image 2"
        }
      ],
      badges: [
        {
          label: "New In",
          badgeType: "new",
          backgroundColor: "#ffffff",
          textColor: "#000000",
          imageSrc: "https://example.com/badge1.png"
        }
      ]
    },
    attributes: [],
    categories: [
      {
        name: "Category 1",
        slug: "category1",
        categoryId: "cat1"
      },
      {
        name: "Category 2",
        slug: "category1/category2",
        categoryId: "cat2"
      }
    ]
  },
  siblingProducts: [
    {
      productId: "1234",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#161316"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1234551",
      productKey: "1243123",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#605960"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1236",
      productKey: "124515",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#FE673E"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "12348",
      productKey: "12431131",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#D0D0D0"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    }
  ]
};
export {
  ia as AttributesAsProgressBar,
  ee as Badges,
  Tt as ButtonGrid,
  We as DetailsWrapper,
  ft as DotIndicator,
  zt as DropdownOnHover,
  Le as Gallery,
  wt as GalleryIndicator,
  vt as IconHeart,
  Bt as IconMinus,
  Lt as IconPlus,
  At as Increment,
  Ae as Name,
  Ot as OneSizeButton,
  ze as Price,
  It as PriceAsBadge,
  Ct as PriceAsSpanProps,
  La as ProductCard,
  Et as ProductInfoText,
  je as QuickshopButton,
  Qt as QuickshopDrawer,
  Gt as QuickshopDrawerSimple,
  ae as QuickshopSelector,
  Fe as QuickshopTemplate,
  jt as STATUS_TRANSLATIONS,
  yt as ScrollIndicator,
  la as SelectTemplate,
  oa as ShortDescription,
  Pt as Swatch,
  te as Swatches,
  ta as Template1,
  ca as Template2,
  Ta as WishlistTrigger,
  ra as attributesAsProgressBarSchema,
  Ba as attributesProgressBarItemSchema,
  Q as badgesSchema,
  he as detailsSchema,
  Aa as discountedExampleProduct,
  ge as gallerySchema,
  Oe as incrementRow,
  za as mockData,
  ja as mockDataMinimal,
  _a as onesSizeMockData,
  V as priceSchema,
  da as productCardPropsSchema,
  Ve as productCardSchema,
  be as productInfoTextSchema,
  De as productOptionsMatchesQuickshopTemplate,
  xt as quickshopButtonSchema,
  Ge as quickshopDrawerSchema,
  Me as quickshopDropdownOnHoverSchema,
  _e as quickshopGridSchema,
  He as quickshopIncrementSchema,
  qe as quickshopOneSizeButtonSchema,
  Rt as quickshopSelectorConfig,
  x as quickshopSelectorProps,
  Ft as quickshopTemplateOptionsSupport,
  Vt as quickshopTemplateSupportConfig,
  Qe as quickshopTemplatesSchema,
  Wa as sharedConfig,
  R as swatchesSchema,
  Jt as template1QuickshopConfig,
  ea as template1Schema,
  na as template2QuickshopConfig,
  sa as template2Schema,
  $e as useAddToCartLabel,
  bt as useScrollBounds,
  ht as useSwipeHint,
  F as wishlistTriggerSchema
};
//# sourceMappingURL=index.es.js.map
